
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {FirebaseDB2} from "../../FirebaseDB2"

import { withTranslation } from 'react-i18next';
import AdComponent from './AdComponent';
import {VisitCounter} from "../../Counter"

// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";



class LiveCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login
    }

    this.previousWidth = -1;
  }

  render() {

    const { t } = this.props;

    return (

      <Container  fluid className={classNames('content', { 'is-open': this.props.isOpen })}>
        {/* <NavBar toggle={this.props.toggle} /> */}

        {/* <LoginContext.login></LoginContext.login> */}

        <FirebaseDB2></FirebaseDB2> 
        
        <VisitCounter name = "live"></VisitCounter>
      </Container>
      
      
    );
  }
}




export default withTranslation()(LiveCom);
